import React from 'react';
import { useTranslation } from 'react-i18next';
import {Container, Step } from './StageRowStyles';

const STAGES = [
    {
        name: '1. Name Plaque Information > ',
        key: 'nameplaqueInfo',
    },
    {
        name: '2. Personal Information > ',
        key: 'personalInfo',
    },
    {
        name: '3. Confirm and Pay',
        key: 'confirmPay',
    },
];

interface Props {
    currentStep?: number,
    steps?: Array<{name: string}>,
    isMobile?: boolean,
    isGeneralProject?: boolean,
}

const StageRow: React.FunctionComponent<Props> = props => {
    const { isMobile } = props;
    const { t } = useTranslation();
    return (
        <Container isMobile={isMobile}>
            {!isMobile ?
                (props.steps && props.steps.map((step, index) =>
                    <Step key={`${index}-${step}`} current={index === props.currentStep} isMobile={isMobile} >
                        {(props.isGeneralProject && index === 0) ? `1. ${t('acknowledgementNameInfo')} > ` : `${index + 1}. ${t(STAGES[index].key)} ${index == 2 ? '' : '>'}`}
                    </Step>
                ))
                :
                (props.steps && props.steps.map((step, index, arr) =>
                    index === props.currentStep ?
                        <Step key={`${index}-${step}`} current={index === props.currentStep} isMobile={isMobile}>
                            {(props.isGeneralProject && index === 0) ? `1. ${t('acknowledgementNameInfo')} / ${arr.length} ` : `${index + 1}. ${t(STAGES[index].key)} / ${arr.length}`}
                        </Step>
                        :
                        null
                ))}
        </Container>
    );
};

StageRow.defaultProps = {
    currentStep: 0,
    steps: STAGES,
}

export default StageRow;
